import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarDaysIcon, UtensilsIcon, ActivityIcon, ShoppingBasketIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: 'El Manual Principal',
  description: 'Guía completa "Metabolismo Silver 21" en formato PDF descargable.'
}, {
  icon: CalendarDaysIcon,
  title: 'Protocolo de 21 Días',
  description: 'Hoja de ruta diaria para eliminar la confusión y saber exactamente qué hacer.'
}, {
  icon: UtensilsIcon,
  title: 'Matriz de Intercambio Silver',
  description: 'Qué comer para no inflamar tu abdomen, con opciones flexibles.'
}, {
  icon: ActivityIcon,
  title: 'Rutina de Movimiento Sin Daño',
  description: '10 minutos de activación para hacer en casa, sin impacto articular.'
}, {
  icon: ShoppingBasketIcon,
  title: 'Lista de Supermercado Silver',
  description: 'Los ingredientes exactos que reactivan tu tiroides y metabolismo.'
}];
export function WhatYouGet() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-12 text-center" data-id="element-166">
          Lo que recibes
        </motion.h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-167">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 border border-sage-primary/30 rounded-xl hover:border-sage-primary hover:shadow-md transition-all" data-id="element-168">
              <item.icon className="w-12 h-12 text-sage-dark mb-4" data-id="element-169" />
              <h3 className="font-semibold text-forest text-lg mb-2" data-id="element-170">
                {item.title}
              </h3>
              <p className="text-forest/70" data-id="element-171">{item.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}